import './bootstrap';
import createJobtoolzApp from './vueApp';
import Feature from "./models/Feature";
import { normalizeJson } from "../shared/helpers";
import { useMainStore } from "./state/store";
import { useRepo } from "pinia-orm";
import { useAuthenticationStore } from "./state/modules/authentication";
import "../shared/alpine";

window.showConfetti = function(x = 0.5, y = 0.5) {
    confetti({
        particleCount: 120,
        gravity: 0.7,
        spread: 120,
        zIndex: 999999,
        origin: { x: x, y: y }
    });
};

(async () => {
    const app = createJobtoolzApp();
    const store = useMainStore();
    const authStore = useAuthenticationStore();

    if (Jobtoolz.features) {
        useRepo(Feature).save(normalizeJson(Jobtoolz.features));
    }

    if (Jobtoolz.user) {
        await authStore.setUser(Jobtoolz.user);
    }

    if (Jobtoolz.revision) {
        await store.setRevision(Jobtoolz.revision);
    }

    if (Jobtoolz.hubspot_meeting) {
        await store.setHubspotUrl(Jobtoolz.hubspot_meeting);
    }

    app.mount("#app");
    Jobtoolz.app = app;
})();

